export default __webpack_public_path__ + "static/media/help--add-figures.96a0b1f7.png";